import type { AuthTokens } from '../types/auth';

const REFRESH_KEY = 'examfolio.refreshToken';
const REFRESH_EXP_KEY = 'examfolio.refreshTokenExpiresAt';

let accessToken: string | null = null;
let accessTokenExpiresAt: string | null = null;

export const tokenStore = {
  setTokens(tokens: AuthTokens): void {
    accessToken = tokens.accessToken;
    accessTokenExpiresAt = tokens.accessTokenExpiresAt;
    localStorage.setItem(REFRESH_KEY, tokens.refreshToken);
    localStorage.setItem(REFRESH_EXP_KEY, tokens.refreshTokenExpiresAt);
  },
  clear(): void {
    accessToken = null;
    accessTokenExpiresAt = null;
    localStorage.removeItem(REFRESH_KEY);
    localStorage.removeItem(REFRESH_EXP_KEY);
  },
  getAccessToken(): string | null {
    return accessToken;
  },
  getAccessTokenExpiresAt(): string | null {
    return accessTokenExpiresAt;
  },
  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_KEY);
  },
};

const TENANT_KEY = 'examfolio.tenantSlug';

export const tenantStore = {
  set(slug: string | null): void {
    if (slug) localStorage.setItem(TENANT_KEY, slug);
    else localStorage.removeItem(TENANT_KEY);
  },
  get(): string | null {
    return localStorage.getItem(TENANT_KEY);
  },
};
